import BusinessDetailPage from './BusinessDetailPage'

export default BusinessDetailPage